import withTracker from '.././withTracker';
import SubscribeConfirm from '../../containers/subscriber/SubscribeConfirm';

const subscribeConfirm = {
  path: '/subscribers/subscribeConfirm',
  component: withTracker(SubscribeConfirm)
};

export default subscribeConfirm;
